export default __webpack_public_path__ + "static/media/logo-dark.2dc52f7a.svg";